import React from 'react'
import { useHistory, useLocation } from 'react-router'
import { Button, Typography, useDimensions } from '@telavita-core/react-design-kit'

import { useScrollToTop } from 'hooks/useScrollToTop'
import { HOME_PSIC, HOME_PSIQ, DASHBOARD_HOME_PATIENT } from 'settings/_routesSettings'

import AlineImage from 'static/images/technical-responsible/aline.png'

import * as S from './styles'

type LocationState = {
  professionalProfileCode: string
}

const PROFESSIONAL_ROUTES = {
  TVTVPSIC: HOME_PSIC,
  TVTVPSIQ: HOME_PSIQ
}

export const NpsNegativeReview = () => {
  useScrollToTop()
  const { isMobile } = useDimensions()
  const location = useLocation<LocationState>()
  const history = useHistory()
  
  const professionalProfileCode = location.state?.professionalProfileCode

  const handleChooseAnotherProfessional = () => {
    history.push(PROFESSIONAL_ROUTES[professionalProfileCode])
  }

  return (
    <S.Container isMobile={isMobile}>
      <Typography variant={isMobile ? 'content2' : 'header4'}>
        Agradecemos a sua avaliação!
      </Typography>
      <Typography variant={isMobile ? 'header4' : 'header3' } weight='bold'>
        Vimos que você não gostou tanto do profissional. <br /> Que tal fazer uma nova tentativa com outro especialista?
      </Typography>

      <S.DisclaimerWrapper isMobile={isMobile}>
        <img 
          loading='lazy'
          src={AlineImage}
          alt="Aline Silva, responsável técnica em Psicologia"
        />
        
        <Typography variant='content2'>
          A psicoterapia requer continuidade, mas é preciso persistir na busca pelo <b>psicólogo certo</b> quando você não 
          se identificar com o profissional numa primeira tentativa. Continue cuidando de você!
        </Typography>
        
        <div>
          <Typography variant='content2' weight='bold'>
            Aline Silva
          </Typography>

          <Typography variant='content2' customClassName='professionalRole'>
            Responsável técnica em Psicologia
          </Typography>
        </div>
      </S.DisclaimerWrapper>
      
      <Button 
        uppercase={false} 
        variant='contained'
        onClick={handleChooseAnotherProfessional}
      >
        Escolher outro profissional
      </Button>

      <Button 
        customClassName='secondaryButton' 
        uppercase={false}
        onClick={() => history.push(DASHBOARD_HOME_PATIENT)}
      >
        Ir para a página inicial
      </Button>
    </S.Container>
  )
}